import React, { useEffect } from 'react'
import './Servicio.css'
import PcOne from './Imagenes/PcOne.png'
import logoBlanco from './Imagenes/logo-blanco.png'
import elemento2 from './Imagenes/elemento-2.png'
import payments from './Imagenes/11.png'
import warranty from './Imagenes/12.png'
import time from './Imagenes/13.png'
import delivery from './Imagenes/14.png'
import CallCenterIcon from './Imagenes/CallCenterIcon.png'
import PcTwo from './Imagenes/PcTwo.png'
import whatsapp from './Imagenes/Whatsapp.png'
import Devices from './Imagenes/Devices.png'
import logoNegro from './Imagenes/logo-negro.png'


function ServicioTecnico() {
    function ScrollToTopOnMount() {
        useEffect(() => {
            window.scrollTo(0, 0);
        }, []);

        return null;
    }
    return (
        <>
            <ScrollToTopOnMount />
            <div className='ServicioTecnico'>
                <div className='topet_container'>
                    <p>Deja en nuestras manos expertas la revisión, mantenimiento y reparación de tus equipos tecnológicos. Tenemos más de 20 años de experiencia brindandoté un servicio de calidad, profesional y con garantía. Cuidamos tus equipos porque sabemos cuan importantes son para para vos.</p>
                    <img className='Pc_One' src={PcOne} />
                </div>
                <div className='Mid_Container'>
                    <img className='Logo_Negro' src={logoNegro} />
                    <div className='ItemsContainer'>
                        <div className="item-container-mid-servicio">
                            <img className='time' src={time} />
                            <div className="item-text-mid-servicio">
                                <h3>Tiempo</h3>
                                <p>Servicio técnico con la mayor rápidez</p>
                            </div>
                        </div>
                        <div className="item-container-mid-servicio">
                            <img className='delivery' src={delivery} />
                            <div className="item-text-mid-servicio">
                                <h3>Confianza</h3>
                                <p>Más de 20 años de experienca</p>
                            </div>
                        </div>
                        <div className="item-container-mid-servicio">
                            <img className='warranty' src={warranty} />
                            <div className="item-text-mid-servicio">
                                <h3>Garantía</h3>
                                <p>Damos la mejor garantía para vos y tus productos</p>
                            </div>
                        </div>
                        <div className="item-container-mid-servicio">
                            <img className='payments' src={payments} />
                            <div className="item-text-mid-servicio">
                                <h3>Forma de Pago</h3>
                                <p>Multiples formas de pago pensadas para tí.</p>
                            </div>
                        </div>
                        <img className='Call_Center' src={CallCenterIcon} />
                    </div>
                </div>
                <div className='Mid_Down_Container'>
                    <div className="left-mid-down">
                        <div id="prueba">
                            <ul> Servicio Técnico
                                <li>Computadoras</li>
                                <li>Consolas de videojuegos</li>
                                <li>Mantenimiento de equipos electrónicos</li>
                                <li>Instalación de software y hardware</li>
                                <li>...y mucho más</li>
                            </ul>
                        </div>
                        <img className='Logo_Negro' src={logoBlanco} />
                    </div>
                    <div className="right-mid-down">
                        <img className='Pc_Two' src={PcTwo} />
                    </div>
                </div>
                <div className='bottom_Container'>
                    <div className='final_Container'>
                        <p>¿Tenés alguna duda? Contactate directamente con nuestro especialista en el área y disfrutá de una asesoría gratuita. Evitá dejar tus equipos en manos de persona no profesionales. Nuestra empresa posee cerca de 200 reseñas positivas de nuestros clientes. Para ver nuestras reseñar hacé  <a
                            href="https://www.google.com/maps/place/La+Consola+Digital/@-32.9832832,-68.796768,15.88z/data=!4m14!1m6!3m5!1s0x967e0cbe515a7533:0xe1b0585e6e8dbe2c!2sLa+Consola+Digital!8m2!3d-32.9823539!4d-68.7901512!3m6!1s0x967e0cbe515a7533:0xe1b0585e6e8dbe2c!8m2!3d-32.9823539!4d-68.7901512!9m1!1b1"
                            target="_blank"
                        ><b>CLICK AQUÍ</b></a> </p>
                        <a href="https://wa.me/542612565651" target="_blank">
                            <img className='bottomWhatsapp' src={whatsapp} />
                        </a>

                    </div>
                    <img className='Devices' src={Devices} />
                </div>

            </div>
        </>
    )
}

export default ServicioTecnico